import { formatCustomDate } from "helpers/dateTools";
import { ActionTypes } from "./types";

const {
    ADD_STATION_SALE_MODE,
    EDIT_STATION_SALE_MODE,
    DELETE_STATION_SALE_MODE,
    OPEN_STATION_SALE_SNACK,
    CLOSE_STATION_SALE_SNACK,
    CREATE_STATION_SALE,
    MOD_STATION_SALE,
    DELETE_STATION_SALE,
    CLEAR_STATION_SALES,
    GET_STATION_SALES,
    GET_STATION_SALES_ACCOUNT_DETAILS,
    GET_STATION_SALES_PAYMENTS_TYPES,
    SET_STATION_SALES_FILTERS,
    STATION_SALE_SELECTED,
    RESET_STATION_SALE_SELECTED,
    
    SET_CONFIG_PAGE_STATION_SALES,
    SET_CONFIG_PAGE_SIZE_STATION_SALES,
    SET_CONFIG_FILTER_STATION_SALES,
    SET_CONFIG_SORTED_STATION_SALES
} = ActionTypes

const INITIAL_STATE = {
    addMode: false,
    deleteMode: false,
    stationSales: [],
    paymentTypes: [],
    startDate: formatCustomDate(new Date(), "-"),
    endDate: formatCustomDate(new Date(), "-"),
    station: null,
    isUnitFilter: true,
    unit: null,
    unitOptions: [],
    account: null,
    accountOptions: [],
    accountDetails: {},
    customerAccountsFilter: '',
    stationSaleSelected: {},
    snackBar: { 
        msg: "", 
        isOpen: false 
    },
    config: {
        page: 0,
        pageSize: 20,
        filtered: [],
        sorted: []
    },
}

export const stationSalesReducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case ADD_STATION_SALE_MODE:
            return {
                ...state,
                addMode: true,
                deleteMode: false
            }

        case EDIT_STATION_SALE_MODE:
            return {
                ...state,
                addMode: false,
                deleteMode: false
            }

        case OPEN_STATION_SALE_SNACK:
            return {
                ...state,
                snackBar: { 
                    msg: payload, 
                    isOpen: true 
                }
            }

        case CLOSE_STATION_SALE_SNACK:
            return {
                ...state,
                snackBar: { 
                    msg: '', 
                    isOpen: false 
                }
            }
    
        case DELETE_STATION_SALE_MODE:
            return {
                ...state,
                addMode: false,
                deleteMode: true
            }

        case STATION_SALE_SELECTED:
            const index = state.stationSales.findIndex(item => item.id === payload)
            if (index === -1) return state;
            else return {
                ...state,
                stationSaleSelected: state.stationSales[index]
            }

        case RESET_STATION_SALE_SELECTED:
            if(state.isUnitFilter) return {
                ...state,
                account: null,
                accountOptions: [],
                accountDetails: {},
                customerAccountsFilter: '',
                stationSaleSelected: {},
                addMode: true,
                deleteMode: false
            }; else return {
                ...state,
                stationSaleSelected: {},
                addMode: true,
                deleteMode: false
            }

        case CLEAR_STATION_SALES:
            return {
                ...state,
                ...INITIAL_STATE,
            };

        case SET_STATION_SALES_FILTERS:
            if(payload.key === 'station') return {
                ...state,
                [payload.key]: payload.data,
                unit: null,
                unitOptions: [],
                account: null,
                accountDetails: {},
                accountOptions: [],
                stationSales: [],
                customerAccountsFilter: '',
            }
            if(payload.key === 'account') return {
                ...state,
                [payload.key]: payload.data,
                accountDetails: {},
            }
            return {
                ...state,
                [payload.key]: payload.data
            };

        case GET_STATION_SALES:
            const formatDates = payload.stationSales.map(sale => {
                const idxPayment = state.paymentTypes.findIndex(type => type.id === sale.idPayment)
                return { 
                    ...sale, 
                    date: formatCustomDate(sale.date, "-") ,
                    paymentType: state.paymentTypes[idxPayment]?.name,
                }
            })
            return {
                ...state,
                stationSales: formatDates,
                station: payload.station,
                startDate: payload.startDate,
                endDate: payload.endDate
            }
        
        case GET_STATION_SALES_ACCOUNT_DETAILS:
            return {
                ...state,
                accountDetails: payload,
            }
        
        case GET_STATION_SALES_PAYMENTS_TYPES:
            return {
                ...state,
                paymentTypes: payload,
            }

        case CREATE_STATION_SALE:
            const idx = state.paymentTypes.findIndex(type => type.id === payload.idPayment)
            return {
                ...state,
                stationSales: [{
                    ...payload, 
                    paymentType: state.paymentTypes[idx]?.name,
                    date: formatCustomDate(payload.date, "-")
                }, ...state.stationSales],
            }

        case MOD_STATION_SALE:
            const newStationSales = [...state.stationSales];
            const stationSaleIdx = newStationSales.findIndex(sale => sale.id === payload.id)
            const idxPtype = state.paymentTypes.findIndex(type => type.id === payload.idPayment)
            if (stationSaleIdx !== -1) {
                newStationSales[stationSaleIdx] = {
                    ...newStationSales[stationSaleIdx],
                    ...payload,
                    paymentType: state.paymentTypes[idxPtype]?.name,
                    date: formatCustomDate(payload.date, "-") 
                };
            }
            return {
                ...state,
                stationSales: newStationSales,
            }

        case DELETE_STATION_SALE:
            return {
                ...state,
                stationSales: state.stationSales.filter(sale => sale.id !== payload),
            }

        case SET_CONFIG_FILTER_STATION_SALES:
            return {
                ...state,
                config: {
                    ...state.config,
                    filtered: payload,
                    page: 0,
                },
            };

        case SET_CONFIG_PAGE_STATION_SALES:
            return {
                ...state,
                config: {
                    ...state.config,
                    page: payload,
                },
            };

        case SET_CONFIG_PAGE_SIZE_STATION_SALES:
            return {
                ...state,
                config: {
                    ...state.config,
                    pageSize: payload,
                    page: 0,
                },
            };

        case SET_CONFIG_SORTED_STATION_SALES:
            return {
                ...state,
                config: {
                    ...state.config,
                    sorted: payload,
                    page: 0,
                }
            };

        default:
            return state;
    }
}